module.exports = __webpack_public_path__ + "img/gallery13.c10a501b.png";